export default __webpack_public_path__ + "static/gynoveda-fd965d464e6cb20f44796095c49bcb54.png";